/* tslint:disable:max-line-length */
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Button } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { useEmailAccountCRUDActions } from '@mm/state/actions/EmailAccountCRUDActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { OAuthPopupActionButton } from '@mm/stateful-components/OAuth/OAuthPopupActionButton';
import { ReactComponent as GoogleIcon } from 'assets/icons/google-colorful-icon.svg';
import { ReactComponent as MicrosoftIcon } from 'assets/icons/microsoft-colorful-icon.svg';
import { ReactComponent as SendGridIcon } from 'assets/sendgrid.svg';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './ActivateEmailAccountModal.module.css';
import { useActivateEmailAccount } from './use-activate-email-account';

export const ActivateEmailAccountModal = () => {
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const featureFlag = 'nativeIntegrations';
  const landmineName = landmineNames.INTEGRATIONS_EMAIL;

  const { getMicrosoftOauthUrl, getGmailOauthUrl, getAccounts } =
    useEmailAccountCRUDActions();
  const { connectManualAccount, connectSendgrid } = useActivateEmailAccount();
  const { closeModal } = useModalActions();

  const onAccountAdded = () => {
    getAccounts(facebookPageId);
    closeModal();
  };

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />
      <div className={styles.heading}>Connect Your Email Account</div>

      <div className={styles.hint}>
        <InfoCircleFilled />
        Email accounts ending with @gmail.com are limited to 5 emails per day.
      </div>

      <p className={styles.hintFollowUp}>
        We encourage you to link a business email, such as a Google workspace
        email account, which is not limited in this way.
      </p>

      <div className={styles.buttons}>
        <OAuthPopupActionButton
          fetchOauthPopupUrl={() =>
            getGmailOauthUrl(facebookPageId, 'post_message')
          }
          oauthSuccessMessageType="googleAccountConnected"
          onRefreshNeeded={onAccountAdded}
          spinnerProps={{ size: 16, width: 32 }}
          featureFlag={featureFlag}
          landmineName={landmineName}
          buttonProps={{
            size: 'md',
            color: 'secondary-blue',
            css: { container: styles.button },
            leftIcon: <GoogleIcon />,
          }}
        >
          Connect with Google
        </OAuthPopupActionButton>

        <OAuthPopupActionButton
          fetchOauthPopupUrl={() => getMicrosoftOauthUrl(facebookPageId)}
          oauthSuccessMessageType="microsoftAccountConnected"
          featureFlag={featureFlag}
          landmineName={landmineName}
          onRefreshNeeded={onAccountAdded}
          spinnerProps={{ size: 16, width: 32 }}
          buttonProps={{
            size: 'md',
            color: 'secondary-blue',
            css: { container: styles.button },
            leftIcon: <MicrosoftIcon />,
          }}
        >
          Connect with Microsoft
        </OAuthPopupActionButton>

        <Button
          size="md"
          color="secondary-blue"
          onClick={() => {
            connectSendgrid();
          }}
          leftIcon={<SendGridIcon />}
          css={{ container: styles.button }}
        >
          Connect with SendGrid
        </Button>
        <Button
          size="md"
          color="secondary-blue"
          onClick={e => {
            e?.stopPropagation();
            connectManualAccount();
          }}
          leftIcon={<div />}
          css={{ container: styles.button }}
        >
          Connect Manually
        </Button>
      </div>
    </div>
  );
};
